export default __webpack_public_path__ + "static/media/codepanda.a6aed048.png";